<template>
  <div id="app">
    <router-view />
    <Loading v-if="isLoading" :type="isLoading"></Loading>
  </div>
</template>

<script>
import Loading from "@components/Loading.vue";
import { mapState } from "vuex";
export default {
  name: "App",
  components: {
    Loading,
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.isShowRequestLoading,
    }),
  },
};
</script>

<style lang="scss">
// @import './assets/fonts/iconfont.css';
@import "./assets/style/flex.css";
@import "./assets/style/font.scss";
@import "./assets/style/color.css";
@import "./assets/style/index.scss";
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

b {
  font-weight: 400;
}

html {
  height: 100%;
}
body {
  height: 100%;
  margin: 0;
  padding: 0;
  background: white;
  overflow-y: overlay;
}
p {
  margin: 0;
}

img {
  vertical-align: baseline;
}

body,
button,
input,
textarea {
  font-family: PingFangSC, PingFangSC-Medium, "Microsoft YaHei", Avenir,
    Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.iconfont {
  outline: none;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
input::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #b4b7bf;
}
.pointer {
  cursor: pointer;
}

.input {
  background: transparent;
  border: 1px solid #dbdfe6;
  color: #242529;
  outline: 0;
  border-radius: 4px;
  width: 200px;
  height: 32px;
}
input:disabled {
  border: 1px solid #ddd;
  background-color: #f5f5f5;
  color: #aca899;
}
.el-select {
  .el-input__inner {
    height: 32px;
  }
  .el-input__icon {
    line-height: 32px;
  }
  ::v-deep input {
    background: rgba(0, 0, 0, 0);
  }
}
</style>
